"use strict";
// 1. Define named imports here
// import { Text } from '@csod/text';
// 2. Export default object with named import
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("player-core/utils");
var player_react_portal_1 = require("player-react-portal");
exports.default = {
    createUUID: utils_1.createUUID,
    addNoScroll: utils_1.addNoScroll,
    removeNoScroll: utils_1.removeNoScroll,
    Portal: player_react_portal_1.Portal
};
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/dialog/build/__exports.js
// module id = 575
// module chunks = 0